import { get_notifications_without_pagination } from "../config/Notifications/notifications";
import { clearNotifications, setNotifications } from "../features/slices/notificationSlice";


// Reusable fetch function
export const fetchNotificationsList = async (dispatch) => {

    try {
        const response = await get_notifications_without_pagination();
        if (response?.status === "success") {
            dispatch(setNotifications(response?.data));
        } else {
            dispatch(clearNotifications());
        }
    } catch (error) {
        console.error("Error fetching notifications:", error);
        dispatch(clearNotifications());
    }
};

// FOR GET NAVIGATION VIA TYPE
export const getNavigationPath = (info) => {
    const idType = Number(info?.ND_Type);
    const scheduleId = Number(info?.ND_scheduleID);
    
    switch (idType) {
        case 1:  // SCHEDULE ASSIGNED by 07-10-25
            return `/worksites/my-schedules/overview`
        case 4:  // FOR Reports Accept/not by 12-7-25
        case 5:  // FOR Reports Completed by 15-7-25
        case 6:  // FOR SCHEDULE ACCEPT
        case 7:  // FOR SCHEDULE REJECT
        case 9:  // FOR SCHEDULE COMPLETED
        case 11: // FOR SCHEDULE QUERY
        case 12: // FOR SCHEDULE QUERY REPLAY
            return `/worksites/schedule/${scheduleId}`;
        case 10: // FOR LEAVES LIST
            return `/leave/leave/list`;
        default:
            return; // `/page-not-found`
    }
};